export const CITY_TO_REGION: Record<string, { slug: string; name: string }> = {
  'alhaurin-de-la-torre': { slug: 'valle-del-guadalhorce', name: 'Valle del Guadalhorce' },
  'alhaurin-el-grande': { slug: 'valle-del-guadalhorce', name: 'Valle del Guadalhorce' },
  'alora': { slug: 'valle-del-guadalhorce', name: 'Valle del Guadalhorce' },
  'antequera': { slug: 'valle-del-guadalhorce', name: 'Valle del Guadalhorce' },
  'cartama': { slug: 'valle-del-guadalhorce', name: 'Valle del Guadalhorce' },
  'coin': { slug: 'valle-del-guadalhorce', name: 'Valle del Guadalhorce' },
  'nerja': { slug: 'axarquia', name: 'Axarquía' },
  'ronda': { slug: 'serrania-de-ronda', name: 'Serranía de Ronda' },
};

// Villes voisines à afficher dans le bloc "También cubrimos en la región"
// Seulement pour les Tier 2 sans hub /zonas/ propre
export const CITY_REGION_CROSS_LINKS: Record<string, string[]> = {
  'cartama': ['alhaurin-de-la-torre', 'coin', 'alora'],
  'antequera': ['alora'],
  'nerja': ['velez-malaga'],
  'alhaurin-de-la-torre': ['cartama', 'alhaurin-el-grande', 'coin'],
  'alhaurin-el-grande': ['alhaurin-de-la-torre', 'cartama', 'coin'],
  'alora': ['cartama', 'antequera'],
  'coin': ['cartama', 'alhaurin-el-grande', 'alhaurin-de-la-torre'],
  'ronda': [],
};